import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Button,
  CssBaseline,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { tokens } from '../../../theme/theme';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';
import CallAlertBar from '../../../Layout/Alertbar';
import AddUpdateBank from './AddUpdateBank';
import { useNavigate } from 'react-router-dom';

const BankIndex = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const [bankList, setBankList] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [bankFormData, setBankFormData] = useState({}); // data for AddUpdateBank

  // Alerts
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('info');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertTitle, setAlertTitle] = useState('');

  const LoadBankList = () => {
    
    callApi(API_ENDPOINTS.MASTER_GET_BANK_LIST, 'POST', { 'Content-Type': 'application/json' })
      .then((data) => {
        if (data && data.length > 0) setBankList(data);
        else {
          setAlertSeverity('warning');
          setAlertTitle('Warning');
          setAlertMessage('No bank data found!');
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setAlertSeverity('error');
        setAlertTitle('Error');
        setAlertMessage('Unable to load bank details');
        setAlertOpen(true);
      });
  };

  useEffect(() => {
    LoadBankList();
  }, []);

  const handleAddBank = () => {
    setBankFormData({}); // empty fields
    setIsFormOpen(true);
  };

  const handleEditBank = (bank) => {
    setBankFormData(bank); // prefill with selected bank
    setIsFormOpen(true);
  };

  const handleBack = () => navigate('/');

  return (
    <Grid>
      {!isFormOpen && (
        <>
          <CssBaseline />
          <AppBar position="static" sx={{ backgroundColor: 'inherit' }}>
            <Toolbar>
              <Typography variant="h4" gutterBottom>
                Bank Master
              </Typography>
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<AccountBalanceIcon />}
                sx={{ ml: 'auto', textTransform: 'none' }}
                onClick={handleAddBank}
              >
                New Bank
              </Button>
              <IconButton onClick={handleBack}>
                <Close style={{ fontSize: '16px', color: '#2196F3' }} />
              </IconButton>
            </Toolbar>
          </AppBar>

          <CallAlertBar
            parentRollMsgOpen={alertOpen}
            setParentRollMsgOpen={setAlertOpen}
            parentRollSeverityvalue={alertSeverity}
            setParentRollSeverityvalue={setAlertSeverity}
            parentRollAlertTitleValue={alertTitle}
            setParentRollAlertTitleValue={setAlertTitle}
            parentRollMessageValue={alertMessage}
            setParentRollMessageValue={setAlertMessage}
          />

          <Grid container padding={1} spacing={1}>
            <Grid item xs={12}>
              <Box
                sx={{
                  '& .MuiTableCell-root': {
                    border: '1px solid',
                    borderColor: `${colors.primary[400]} !important`,
                    padding: '4px',
                  },
                  maxHeight: '75vh',
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': { width: '8px' },
                  '&::-webkit-scrollbar-thumb': {
                    background: colors.blueAccent[600],
                    borderRadius: '10px',
                  },
                }}
              >
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>BANK CODE</TableCell>
                        <TableCell>BANK NAME</TableCell>
                        <TableCell>STATUS</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {bankList.map((bank) => (
                        <TableRow key={bank.sbank_id}>
                          <TableCell
                            sx={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => handleEditBank(bank)}
                          >
                            {bank.sbank_code}
                          </TableCell>
                          <TableCell>{bank.sbank_name}</TableCell>
                          <TableCell>{bank.sbank_status}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      )}

      {isFormOpen && (
        <AddUpdateBank
          bankFormData={bankFormData}
          setBankFormData={setBankFormData}
          setIsFormOpen={setIsFormOpen}
          LoadBankList={LoadBankList}
        />
      )}
    </Grid>
  );
};

export default BankIndex;
